import React from 'react';
import { connect } from 'react-redux';

import './Layout.scss';
import Topbar from '../components/Topbar';

const Layout = (props) => {
  return <>{<Topbar>{props.children}</Topbar>}</>;
};

const mapStateToProps = (state) => {
  return {};
};

export default connect(mapStateToProps)(Layout);
